import React from "react";
import {useAppStore} from "../../common/app.store.consumer";
import {QuestionItem as Question} from "../../common/webapicall";
import {AppStore} from "../../stores/app.store";
import ProfessionalProfileQuestionDebugDetails from "./questionnaire-debug/question.debug.details";

interface Props {
	appStore?: AppStore;
	questionNumber: number;
	question: Question;
}

@useAppStore()
export default class QuestionItem extends React.Component<Props> {
	private handleAnswerChange = (qId: string, answer: boolean) => {
		this.props.appStore.questionnaireStore.handleAnswerChange(qId, answer);
	};

	private getActiveButtonClass = (answer?: boolean, negate: boolean = false) => {
		let baseClass = "cih-btn cih-answer-btn";
		if (answer === null) return baseClass;
		const state = negate ? !answer : answer;
		return baseClass + (state ? " active" : "");
	};

	render() {
		const isDebugEnabled = this.props.appStore.configuration.isDebugPanelEnabled;
		const q = this.props.question;

		return (
			<div className="cih-question-container">
				<div className="question-num">{this.props.questionNumber}</div>
				<div className="question">
					{q.text}
					<ProfessionalProfileQuestionDebugDetails questionId={q.questionId} questionVariantId={q.questionVariantId} debugDetails={q.debugDetails} answer={q.answer} isEnabled={isDebugEnabled} />
				</div>
				<div className="cih-btn-group">
					<button className={this.getActiveButtonClass(q.answer)} onClick={() => this.handleAnswerChange(q.questionId, true)}>
						Yes
					</button>
					<button className={this.getActiveButtonClass(q.answer, true)} onClick={() => this.handleAnswerChange(q.questionId, false)}>
						No
					</button>
				</div>
			</div>
		);
	}
}
